import React from 'react'
import VisibilityIcon from '@mui/icons-material/Visibility'
import { Chip, FunderNameText } from '../Goals/Goals.styled'

type CollaborativeGoalChipProps = {
  direction: 'with' | 'from'
  funderSharedGoalName: string
  iconColorStyles: Record<string, unknown>
  funderCount?: number
}

export const CollaborativeGoalChip = ({
  direction,
  funderSharedGoalName,
  iconColorStyles,
  funderCount,
}: CollaborativeGoalChipProps) => {
  if (!funderSharedGoalName) return null

  return (
    <Chip variant='shared'>
      <VisibilityIcon sx={iconColorStyles} />
      {funderCount && funderCount > 1 ? (
        <>Shared with {funderCount} funders</>
      ) : (
        <>
          Shared {direction}{' '}
          <FunderNameText>{funderSharedGoalName}</FunderNameText>
        </>
      )}
    </Chip>
  )
}
